module.exports = __webpack_public_path__ + "static/media/main_img.c64dd7f0.svg";